module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/education-quiz-small.3cbc8dba985b9418cac642ee7ccb7ee4.jpg";